<div class="content">
    <color-widget [formControl]="formControl" trans>Canvas Background</color-widget>
</div>